<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part1">
<h1><a id="page_16"></a><a href="#/003toc#part1">Chapter 1</a></h1>
<h1><a href="#/003toc#part1">Souper Bowls—Soups and Chilies</a></h1>
<p class="noindent">The slow cooker is made for slow-cooked soups and chilies. A bowl of comfort can be prepped and then tossed into the slow cooker for a day of slow simmering. Warming bowls of soup can be the balm that soothes your family after a hectic day. Serve the soups in hollowed-out bread bowls or with biscuits, crusty breads, or cornbread, and you’ll have your family singing the hallelujah chorus. The best part is that you put the ingredients in the slow cooker in the morning, and at the end of the day you will come home to a pot of delicious homemade soup.</p>
<p class="noindent">Chilies are also terrific to make in the slow cooker. Sauté the ingredients ahead of time to allow the dried spices to bloom, then stir it all together in the slow cooker to simmer for hours. You’ll come home to a pot full of spicy goodness to soothe and satisfy after a long day.</p> <a id="page_17"></a><a id="page_18"></a>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006-part1.vue?77d6774d